// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraTextBoxTemplate from '@front/templates/TerceraTextBoxTemplate.html';
import { Control } from './Control';
import { ControlsTypes } from '../../Controls/UtilsClasses/FactoryConstants';
import $ from 'jquery';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class TerceraTextBox extends Control {
    constructor() {
        super(...arguments);
        this.inputElement = null; // ref to <input> html element
    }
    getType() {
        return ControlsTypes.TerceraTextBox;
    }
    oninit() {
        super.oninit();
        this.on('focus', this.private_Focus);
        this.on('blur', this.private_Blur);
        this.observe('text', this.private_textChange);
    }
    oncomplete() {
        super.oncomplete();
        this.observe('focused', this.onFocusedChanged); // uncomment 83805
        if (this.get('autofocus')) {
            void this.set('focused', true);
        }
    }
    onSubmitEvent(event) {
        if (event === null || event === void 0 ? void 0 : event.original) {
            event.original.preventDefault();
        }
    }
    getInputElement() {
        if (isNullOrUndefined(this.inputElement)) {
            const arr = $(this.find('div input'));
            if (arr) {
                this.inputElement = arr[0];
            }
        }
        return this.inputElement;
    }
    onFocusedChanged(newVal) {
        const input = this.getInputElement();
        if (newVal) {
            input.focus();
        }
        else {
            input.blur();
        }
    }
    getAbsoluteRectangle() {
        return ControlsUtils.getAbsoluteRectangleForElement(this);
    }
    private_textChange(newText, oldText) {
        const result = this.validateValue(newText);
        if (!result) {
            // отменить  изменение и всплытие события если символы недопустимы!!!
            void this.set({ text: oldText });
        }
        // ! надо сохранять последний текст? !
        this.fire(TextBoxEvents.TextChanged, this.get('text'));
    }
    private_Focus(e) {
        if (!this.get('enabled'))
            return;
        if (this.get('skipfocus')) {
            void this.set('skipfocus', false);
            e.node.setSelectionRange(e.node.value.length, e.node.value.length);
            return;
        }
        // Cross-browser hack for the different "input.select()" behaviours after focusing.
        // https://www.impressivewebs.com/input-select-correct-behaviour/
        const inputEl = e.node;
        // setTimeout(function () { inputEl.select(); }, 0);
        inputEl.select();
        void this.set('focused', true);
    }
    private_Blur() {
        void this.set('focused', false);
    }
    selectAll() {
        this.getInputElement().select();
    }
    validateValue(newText) {
        const regexp = this.get('inputPatern');
        if (regexp) {
            return regexp.test(newText);
        }
        return true;
    }
}
export var TextBoxEvents;
(function (TextBoxEvents) {
    TextBoxEvents["KeyDown"] = "keyDown";
    TextBoxEvents["TextChanged"] = "TextChanged";
    TextBoxEvents["KeyUp"] = "keyUp";
})(TextBoxEvents || (TextBoxEvents = {}));
Control.extendWith(TerceraTextBox, {
    template: TerceraTextBoxTemplate,
    data: function () {
        return {
            maxLength: 200, // максимальная длинна
            isReadOnly: false, // редактируемое поле
            placeholder: '',
            isMaterialDesign: true,
            text: '', // значение
            inputPatern: null, // патерн допустимых элементов g - флаг не использовать!  пример new RegExp('[1-9]')
            haveError: false,
            autofocus: false,
            inputType: 'text', // input element's type attribute (text/password)
            elementStyle: 'js-input-container',
            additionalClass: '',
            svgIcon: ''
        };
    },
    computed: {
        getInputId: function () {
            return this.get('name') + this._guid;
        }
    }
});
